import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    email: '',
    role: '',
    message: ''
  });

  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://v1.nocodeapi.com/jackies3668/google_sheets/tDDIfTJPaRQIhmfe?tabId=Sheet1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: "follow",
        body: JSON.stringify([[
          formData.name,
          formData.organization,
          formData.email,
          formData.role,
          formData.message,
          new Date().toLocaleDateString()
        ]])
      });

      await response.json();

      setFormData({
        name: '',
        organization: '',
        email: '',
        role: '',
        message: ''
      });

      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2000);

    } catch (error) {

    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-text">
          <h2><em>contact</em></h2>
          <p>
            Whether it’s feedback on my work, a cool project idea, or just a friendly hello,
            I’d love to hear from you. Whether it’s CSS or Emails, I’m responsive.
          </p>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-row">
            <div className="contact-field">
              <label>Name*</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="contact-field">
              <label>Organization*</label>
              <input type="text" name="organization" value={formData.organization} onChange={handleChange} required />
            </div>
          </div>
          <div className="contact-row">
            <div className="contact-field">
              <label>Email*</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="contact-field">
              <label>Role*</label>
              <input type="text" name="role" value={formData.role} onChange={handleChange} required />
            </div>
          </div>
          <div className="contact-field full">
            <label>Message</label>
            <textarea
              rows="4"
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
          </div>
          <div className="submit-wrap">
            {showPopup && <div className="form-popup">Message Sent!</div>}
            <button type="submit">
              SEND <span className="arrow">↗</span>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
